import React, { useState, useEffect, useRef } from "react";
import { downloadCsv } from "../common/sharedFunctions";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";
import { colors } from "../components/Theme/WebTheme";
import { Modal, Grid, Typography, TextField, Button } from "@mui/material";
// import Button from "components/CustomButtons/Button.js";
import CancelIcon from "@mui/icons-material/Cancel";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { makeStyles } from "@mui/styles";
import AlertDialog from "../components/AlertDialog";
import "../styles/style.css";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  heading: {
    marginBottom: 20,
    height: "10%",
  },
  submit1: {
    marginLeft: 30,
  },
  submit: {
    backgroundColor: "#de7d1e",
  },
  submit5: {
    backgroundColor: "#0c5c6b",
  },
  submit3: {
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
  modal: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
  },
  submit4: {
    backgroundColor: "red",
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
}));

export default function Users() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists,
    fetchUsersOnce,
    updateLicenseImage,
  } = api;
  const settings = useSelector((state) => state.settingsdata.settings);
  const [data, setData] = useState([]);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const classes = useStyles();
  const rootRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setediting] = useState(false);
  const [oldData, setOlddata] = useState("");
  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleAddrow = (newData) => {
    console.log(newData, "ggg");
    new Promise((resolve, reject) => {
      console.log(newData, "testing data");
      setTimeout(() => {
        checkUserExists(newData).then((res) => {
          if (res.users && res.users.length > 0) {
            alert(t("user_exists"));
            reject();
          } else if (!(newData && newData.firstName)) {
            alert(t("proper_input_name"));
            reject();
          } else if (res.error) {
            alert(t("email_or_mobile_issue"));
            reject();
          } else if (
            settings &&
            settings.imageIdApproval &&
            (newData.verifyIdImage === "" || !newData.verifyIdImage)
          ) {
            alert(t("upload_id_details"));
            reject();
          } else if (
            settings &&
            settings.imageIdApproval &&
            !newData.verifyId
          ) {
            alert(t("upload_id_details"));
            reject();
          } else {
            newData["usertype"] = "customer";
            newData["createdAt"] = new Date().getTime();
            const c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const reference = [...Array(5)]
              .map((_) => c[~~(Math.random() * c.length)])
              .join("");
            newData["referralId"] = reference;
            delete newData.tableData;
            let role = auth.profile.usertype;
            if (role === "fleetadmin") {
              newData["fleetadmin"] = auth.profile.uid;
            }
            dispatch(addUser(newData));
            dispatch(fetchUsersOnce());
            resolve();
          }
        });
      }, 600);
    });
  };
  const handleUpdateRow = (newData, oldData) => {
    // newData.id = oldData.id;
    if (newData.verifyIdImage == undefined) {
      newData.verifyIdImage = "";
    }
    console.log("newData", newData);
    console.log("oldData", oldData);
    new Promise((resolve, reject) => {
      setTimeout(() => {
        if (!(newData && newData.firstName)) {
          alert(t("proper_input_name"));
          reject();
        } else if (
          settings &&
          settings.imageIdApproval &&
          (newData.verifyIdImage === "" || !newData.verifyIdImage)
        ) {
          alert(t("upload_id_details"));
          reject();
        } else if (settings && settings.imageIdApproval && !newData.verifyId) {
          alert(t("upload_id_details"));
          reject();
        } else {
          resolve();
          if (newData !== oldData) {
            delete newData.tableData;
            dispatch(editUser(oldData.id, newData));
            dispatch(fetchUsersOnce());
          }
        }
      }, 600);
    });
  };
  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      setData(
        staticusers.filter(
          (user) =>
            user.usertype === "customer" &&
            ((user.fleetadmin === auth.profile.uid &&
              auth.profile.usertype === "fleetadmin") ||
              auth.profile.usertype === "admin")
        )
      );
    } else {
      setData([]);
    }
    loaded.current = true;
  }, [staticusers, auth.profile]);

  const columns = [
    {
      title: t("createdAt"),
      field: "createdAt",
      editable: "never",
      defaultSort: "desc",
      render: (rowData) =>
        rowData.createdAt ? moment(rowData.createdAt).format("lll") : null,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "left" },
    },
    {
      title: t("first_name"),
      field: "firstName",
      cellStyle: { textAlign: isRTL === "rtl" ? "center" : "left" },
    },
    {
      title: t("last_name"),
      field: "lastName",
      cellStyle: { textAlign: isRTL === "rtl" ? "center" : "left" },
    },
    {
      title: t("mobile"),
      field: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("email"),
      field: "email",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "left" },
      headerStyle: { textAlign: "center" },
    },
    {
      title: t("profile_image"),
      field: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 50, borderRadius: "50%" }}
          />
        ) : null,
      editable: "never",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "left" },
    },
    // {
    //   title: t("verify_id"),
    //   field: "verifyId",
    //   cellStyle: { textAlign: isRTL === "rtl" ? "center" : "left" },
    // },
    // {
    //   title: t("verifyid_image"),
    //   field: "verifyIdImage",
    //   cellStyle: { textAlign: "center" },
    //   render: (rowData) =>
    //     rowData.verifyIdImage ? (
    //       <button
    //         onClick={() => {
    //           onClick(rowData, "verifyIdImage");
    //         }}
    //       >
    //         <img
    //           alt="License"
    //           src={rowData.verifyIdImage}
    //           style={{ width: 100 }}
    //         />
    //       </button>
    //     ) : null,
    // },
    {
      title: t("account_approve"),
      field: "approved",
      type: "boolean",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "left" },
    },
    {
      title: t("wallet_balance"),
      field: "walletBalance",
      type: "numeric",
      editable: "never",
      initialEditValue: 0,
      cellStyle: { textAlign: isRTL === "rtl" ? "center" : "center" },
    },
    // {
    //   title: t("signup_via_referral"),
    //   field: "signupViaReferral",
    //   editable: "never",
    //   cellStyle: { textAlign: isRTL === "rtl" ? "right" : "left" },
    // },
    // {
    //   title: t("referralId"),
    //   field: "referralId",
    //   editable: "never",
    //   initialEditValue: "",
    //   cellStyle: { textAlign: isRTL === "rtl" ? "center" : "left" },
    // },
    {
      title: t("bankName"),
      field: "bankName",
      hidden: settings.bank_fields === false ? true : false,
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("bankCode"),
      field: "bankCode",
      hidden: settings.bank_fields === false ? true : false,
      initialEditValue: "",
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    // {
    //   title: t("bankAccount"),
    //   field: "bankAccount",
    //   hidden: settings.bank_fields === false ? true : false,
    //   initialEditValue: "",
    //   cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    // },
  ];

  const [profileModal, setProfileModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [imageData, setImageData] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageType, setImageType] = useState(null);
  const [userData, setUserData] = useState();
  const [loading, setLoading] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const onClick = (rowData, text) => {
    if (text === "verifyIdImage") {
      setImageType(text);
      setImageData(rowData.verifyIdImage);
    }
    setProfileModal(true);
    setUserData(rowData);
  };

  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  };

  const handleSetProfileModal = (e) => {
    e.preventDefault();
    if (selectedImage) {
      setLoading(true);
      dispatch(updateLicenseImage(userData.id, selectedImage, imageType));
      setProfileModal(false);
      setSelectedImage(null);
      setTimeout(() => {
        setLoading(false);
        dispatch(fetchUsersOnce());
      }, 10000);
    } else {
      setCommonAlert({ open: true, msg: t("choose_image_first") });
    }
  };

  return !loaded.current ? (
    <CircularLoading />
  ) : (
    <div>
      <MaterialTable
        // title={t("riders")}
        title={<span className="tableTitleStyle">{t("riders")}</span>}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "16px",
          // marginTop: 30,
          boxShadow: "rgba(0, 0, 0, 0.1) 0px -0.4rem 3rem",
        }}
        data={data}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow.tableData.id)
        }
        options={{
          exportCsv: (columns, data) => {
            let hArray = [];
            const headerRow = columns.map((col) => {
              if (typeof col.title === "object") {
                return col.title.props.text;
              }
              hArray.push(col.field);
              return col.title;
            });
            const dataRows = data.map(({ tableData, ...row }) => {
              row.createdAt =
                new Date(row.createdAt).toLocaleDateString() +
                " " +
                new Date(row.createdAt).toLocaleTimeString();
              let dArr = [];
              for (let i = 0; i < hArray.length; i++) {
                dArr.push(row[hArray[i]]);
              }
              return Object.values(dArr);
            });
            const { exportDelimiter } = ",";
            const delimiter = exportDelimiter ? exportDelimiter : ",";
            const csvContent = [headerRow, ...dataRows]
              .map((e) => e.join(delimiter))
              .join("\n");
            const csvFileName = "download.csv";
            downloadCsv(csvContent, csvFileName);
          },
          exportButton: {
            csv: settings.AllowCriticalEditsAdmin,
            pdf: false,
          },
          maxColumnSort: "all_columns",
          rowStyle: (rowData) => ({
            fontSize: "12px",
            //   backgroundColor:
            //selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
          }),
          editable: {
            // backgroundColor: colors.Header_Text,

            fontSize: "12px",
            //fontWeight: "bold ",
            // fontFamily: 'Lucida Console", "Courier New", monospace',
          },
          headerStyle: {
            position: "sticky",
            top: "0px",
            backgroundColor: "#e1e7f0",
            // backgroundColor: colors.Header_Text_back,
            // color: "#fff",
            color: "#000",
            fontSize: "12px",
            fontWeight: "bold ",
            // fontFamily: 'Lucida Console", "Courier New", monospace',
          },
        }}
        localization={{
          body: {
            addTooltip: t("add"),
            deleteTooltip: t("delete"),
            editTooltip: t("edit"),
            emptyDataSourceMessage: t("blank_message"),
            editRow: {
              deleteText: t("delete_message"),
              cancelTooltip: t("cancel"),
              saveTooltip: t("save"),
            },
          },
          toolbar: {
            searchPlaceholder: t("search"),
            exportTitle: t("export"),
          },
          header: {
            actions: t("actions"),
          },
          pagination: {
            labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
            firstTooltip: t("first_page_tooltip"),
            previousTooltip: t("previous_page_tooltip"),
            nextTooltip: t("next_page_tooltip"),
            lastTooltip: t("last_page_tooltip"),
          },
        }}
        actions={[
          {
            icon: "edit",
            onClick: (event, rowData) => {
              // Do save operation
              setediting(true);
              setOlddata(rowData);
              handleOpenModal();
            },
          },
          {
            icon: "add",
            tooltip: "Add Row",
            isFreeAction: true,
            onClick: handleOpenModal,
          },
        ]}
        editable={{
          // onRowAdd: (newData) =>
          //   new Promise((resolve, reject) => {
          //     console.log(newData, "testing data");
          //     setTimeout(() => {
          //       checkUserExists(newData).then((res) => {
          //         if (res.users && res.users.length > 0) {
          //           alert(t("user_exists"));
          //           reject();
          //         } else if (!(newData && newData.firstName)) {
          //           alert(t("proper_input_name"));
          //           reject();
          //         } else if (res.error) {
          //           alert(t("email_or_mobile_issue"));
          //           reject();
          //         } else if (
          //           settings &&
          //           settings.imageIdApproval &&
          //           (newData.verifyIdImage === "" || !newData.verifyIdImage)
          //         ) {
          //           alert(t("upload_id_details"));
          //           reject();
          //         } else if (
          //           settings &&
          //           settings.imageIdApproval &&
          //           !newData.verifyId
          //         ) {
          //           alert(t("upload_id_details"));
          //           reject();
          //         } else {
          //           newData["usertype"] = "customer";
          //           newData["createdAt"] = new Date().getTime();
          //           const c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          //           const reference = [...Array(5)]
          //             .map((_) => c[~~(Math.random() * c.length)])
          //             .join("");
          //           newData["referralId"] = reference;
          //           delete newData.tableData;
          //           let role = auth.profile.usertype;
          //           if (role === "fleetadmin") {
          //             newData["fleetadmin"] = auth.profile.uid;
          //           }
          //           dispatch(addUser(newData));
          //           dispatch(fetchUsersOnce());
          //           resolve();
          //         }
          //       });
          //     }, 600);
          //   }),
          // onRowUpdate: (newData, oldData) =>
          //   new Promise((resolve, reject) => {
          //     console.log("newData", newData);
          //     console.log("oldData", oldData);

          //     setTimeout(() => {
          //       if (!(newData && newData.firstName)) {
          //         alert(t("proper_input_name"));
          //         reject();
          //       } else if (
          //         settings &&
          //         settings.imageIdApproval &&
          //         (newData.verifyIdImage === "" || !newData.verifyIdImage)
          //       ) {
          //         alert(t("upload_id_details"));
          //         reject();
          //       } else if (
          //         settings &&
          //         settings.imageIdApproval &&
          //         !newData.verifyId
          //       ) {
          //         alert(t("upload_id_details"));
          //         reject();
          //       } else {
          //         resolve();
          //         if (newData !== oldData) {
          //           delete newData.tableData;
          //           dispatch(editUser(oldData.id, newData));
          //           dispatch(fetchUsersOnce());
          //         }
          //       }
          //     }, 600);
          //   }),
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    dispatch(deleteUser(oldData.id));
                    dispatch(fetchUsersOnce());
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
        }}
      />
      <AddAdminModal
        open={modalOpen}
        onClose={handleCloseModal}
        handleAddrow={handleAddrow}
        oldData={oldData}
        editing={editing}
        setediting={setediting}
        handleUpdateRow={handleUpdateRow}
        setOlddata={setOlddata}
      />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6">
              {t("license_image")}
              <input
                type="file"
                style={{ marginLeft: 10 }}
                name={t("image")}
                onChange={(event) => {
                  setSelectedImage(event.target.files[0]);
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage && !loading ? (
              <Tooltip title={t("cancel")}>
                <CancelIcon
                  onClick={() => setSelectedImage(null)}
                  style={{
                    fontSize: 30,
                    backgroundColor: "red",
                    borderRadius: 50,
                    color: "white",
                  }}
                />
              </Tooltip>
            ) : null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage ? (
              <img
                alt="not fount"
                height={"200px"}
                src={URL.createObjectURL(selectedImage)}
                style={{ marginTop: 15, marginBottom: 20 }}
              />
            ) : (
              <img
                alt="licimage"
                height={"200px"}
                src={imageData}
                style={{ marginTop: 10 }}
              />
            )}
            <br />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
          >
            {loading ? (
              <Grid
                container
                spacing={0}
                alignItems="center"
                justify="center"
                style={{ minHeight: "5vh" }}
              >
                <CircularProgress />
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
              >
                <Button
                  onClick={handleProfileModal}
                  variant="contained"
                  // color="danger"
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={handleSetProfileModal}
                  variant="contained"
                  color="secondary"
                  style={{ marginLeft: 10 }}
                >
                  {t("save")}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}

const AddAdminModal = ({
  open,
  onClose,
  handleAddrow,
  editing,
  oldData,
  setediting,
  handleUpdateRow,
  setOlddata,
}) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [verifyId, setverifyId] = useState("");
  const [verifyIdImage, setverifyIdImage] = useState("");
  const [approved, setApproved] = useState(false);
  const [errors, setErrors] = useState({});
  const [walletBalance, setwalletBalance] = useState(0);
  const schema = yup.object().shape({
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    mobileNumber: yup.string().required("Mobile Number is required"),
    // .matches(/^\d{10}$/, "Mobile Number must be a 10-digit number"),
    email: yup.string().required("Email is required").email("Invalid Email"),
  });

  const validateForm = async () => {
    try {
      await schema.validate(
        { firstName, lastName, mobileNumber, email },
        { abortEarly: false }
      );
      setErrors({});
      return true;
    } catch (validationErrors) {
      const errorsMap = {};
      validationErrors.inner.forEach((error) => {
        errorsMap[error.path] = error.message;
      });
      setErrors(errorsMap);
      return false;
    }
  };
  useEffect(() => {
    if (oldData) {
      setFirstName(oldData?.firstName);
      setLastName(oldData?.lastName);
      setMobileNumber(oldData?.mobile);
      setEmail(oldData?.email);
      setverifyId(oldData?.verifyId);
      setverifyIdImage(oldData?.verifyIdImage);
      setApproved(oldData?.approved);
      setwalletBalance(oldData?.walletBalance);
    }
  }, [oldData]);
  const handleAddAdmin = async () => {
    const isValid = await validateForm();
    if (!isValid) return;

    // Perform your logic to add the admin here
    let paramdata = {
      firstName: firstName,
      lastName: lastName,
      mobile: mobileNumber,
      email: email,
      verifyId: verifyId,
      verifyIdImage: verifyIdImage,
      approved: approved,
      walletBalance: walletBalance,
    };
    let dataold = oldData;
    let oldObjectKeys = Object.keys(oldData);
    let newObjectkeys = Object.keys(paramdata);
    let commonKeys = getCommonElements(oldObjectKeys, newObjectkeys);
    commonKeys.forEach((val) => {
      delete oldData[val];
    });

    const latestObj = { ...oldData, ...paramdata };
    if (editing) {
      handleUpdateRow(latestObj, dataold);
    } else {
      handleAddrow(paramdata);
    }
    setediting(false);
    // Reset the form
    setFirstName("");
    setLastName("");
    setMobileNumber("");
    setEmail("");
    setverifyId("");
    setverifyIdImage("");
    setApproved(false);
    setwalletBalance("");
    setErrors("");
    // Close the modal
    onClose();
  };

  const handleClose = () => {
    // Reset the form
    setFirstName("");
    setLastName("");
    setMobileNumber("");
    setEmail("");
    setediting(false);
    setverifyId("");
    setverifyIdImage("");
    setApproved(false);
    setwalletBalance("");
    setErrors("");
    setOlddata("");
    // Close the modal
    onClose();
  };

  function getCommonElements(array1, array2) {
    return array1.filter((element) => array2.includes(element));
  }
  return (
    <Modal open={open} onClose={handleClose}>
      <div
        className="modal-container"
        style={{
          backgroundColor: "white",
          width: "80%",
          margin: "auto",
          marginTop: "3vh",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "scroll",
          maxHeight: "90vh", // Add max height for scrolling
          scrollbarWidth: "thin", // Width of the scrollbar
          scrollbarColor: "#888 #f1f1f1", // Color of the scrollbar thumb and track
        }}
      >
        <h2>{editing ? "Edit" : "Add"} Customers</h2>
        <TextField
          label="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          error={errors.firstName !== undefined}
          helperText={errors.firstName}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <TextField
          label="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          error={errors.lastName !== undefined}
          helperText={errors.lastName}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <TextField
          label="Mobile Number"
          value={mobileNumber}
          placeholder="+15555551234"

          // disabled={editing}
          onChange={(e) => setMobileNumber(e.target.value)}
          error={errors.mobileNumber !== undefined}
          helperText={errors.mobileNumber}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <TextField
          label="Email (Username)"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={errors.email !== undefined}
          helperText={errors.email}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <div
          style={{ width: "100%", marginBottom: "10px", alignItem: "center" }}
        >
          {/* <TextField
            label="Id/Passport Number"
            value={verifyId}
            onChange={(e) => setverifyId(e.target.value)}
            // error={errors.mobileNumber !== undefined}
            // helperText={errors.mobileNumber}
            style={{ flex: 1, marginBottom: "10px" }}
          />
          <TextField
            label="Id/Passport Image"
            value={verifyIdImage}
            onChange={(e) => setverifyIdImage(e.target.value)}
            // error={errors.email !== undefined}
            // helperText={errors.email}
            style={{ flex: 1, marginBottom: "10px" }}
          /> */}
          <div
            style={{
              alignSelf: "center",
              paddingLeft: 25,
              alignItem: "center",
              gap: 4,
            }}
          >
            <label style={{ color: "gray", fontSize: 14 }}>
              Account Approved
            </label>
            <input
              label="Approved"
              type="checkbox"
              checked={approved}
              onChange={(e) => setApproved(e.target.checked)}
              // error={errors.approved !== undefined}
              // helperText={errors.approved}
              style={{ flex: 1, marginBottom: "10px" }}
            />
          </div>
        </div>
        <div className="button-container" style={{ marginTop: "20px" }}>
          {/* <Button variant="contained" onClick={handleAddAdmin}>
            {editing ? "Update" : "Add"}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            style={{ marginLeft: "10px" }}
          >
            Cancel
          </Button> */}
          <Button
            variant="contained"
            onClick={handleAddAdmin}
            style={{ backgroundColor: "darkblue", color: "white" }}
          >
            {editing ? "Update" : "Add"}
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            style={{
              backgroundColor: "darkblue",
              color: "white",
              marginLeft: "10px",
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};
